import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getStafferstype = async ({ commit }) => {
  commit('setStaffertypeIsLoading', true);
  let url = `/stafferstype/selectable`;

  await connection.get(url)
    .then(res => {
      const stafferstype = res.data.data;
      commit('setStafferstypeSelectable', stafferstype);
      commit('setStaffertypeIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStaffertypeIsLoading', false);
    });
}

export const loadStafferstype = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setStaffertypeIsLoading', true);
    let url = `/stafferstype`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const stafferstype = res.data.data;
        commit('setStafferstype', stafferstype);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setStafferstypePaginated', res.data);
        commit('setStaffertypeIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setStaffertypeIsLoading', false);
      });
}

export const staffertypeById = async ({ commit }, id) => {
  commit('setStaffertypeIsLoading', true);
  await connection.get(`/stafferstype/${id}`)
    .then(res => {
      commit('setStaffertypeDetail', res.data.data);
      commit('setStaffertypeIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStaffertypeIsLoading', false);
    });
}

export const storeStaffertype = async ({ commit }, staffertype) => {
  commit('setStaffertypeIsCreating', true);
  await connection.post(`/stafferstype/create`, staffertype)
    .then(res => {
      commit('saveNewStafferstype', res.data.data);
      commit('setStaffertypeIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStaffertypeIsCreating', false);
    });
}

export const updateStaffertype = async ({ commit }, staffertype ) => {
  commit('setStaffertypeIsUpdating', true);
  await connection.put(`/stafferstype/${staffertype.id}/update`, staffertype)
    .then(res => {
      commit('saveUpdatedStaffertype', res.data.data);
      commit('setStaffertypeIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStaffertypeIsUpdating', false);
    });
}

export const deleteStaffertype = async ({ commit }, staffertype) => {
  commit('setStaffertypeIsDeleting', true);
  await connection.delete(`/stafferstype/${staffertype.id}/delete`)
    .then(res => {
      console.log(res);
      commit('setDeleteStaffertype', res.data.data);
      commit('setStaffertypeIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setStaffertypeIsDeleting', false);
    });
}
